import React, {Component} from 'react';
import { scaleLinear } from 'd3';
import percentile from 'percentile';

class VisUitleg extends Component {

	state = {
		data: [ -1.8, -1.5, -1.4, -1.3, -1.2, -1, -0.7, -0.5, 0.1, 0.2, 0.4, 0.6, 0.7, 0.8, 0.9, 1, 1.8, 2.2, 2.4, 4, 4.8],
		domain: [-3,5],
	}

	closest = (array,num) => {
	    var i=0;
	    var minDiff=1000;
	    var ans;
	    for(i in array){
	         var m=Math.abs(num-array[i]);
	         if(m<minDiff){
	                minDiff=m;
	                ans=array[i];
	            }
	      }
	    return ans;
	}

	handleMouseMove = event => {
		const xRect = event.target.getBoundingClientRect().left;
		const widthRect = event.target.getBoundingClientRect().width;
		const mapScale = scaleLinear().range(this.state.domain).domain([xRect,xRect+widthRect]);
		const closestX = this.closest(this.state.data, mapScale(event.nativeEvent.x));
		this.setState({ dot: closestX })
	}

	handleMouseOut = () => {
		this.setState({ dot: null })
	}

 render(){
	const { data, dot, domain } = this.state;
	const { highlights, currentStep } = this.props;

	const invissible  = {
		opacity: 0,
		transition: 'opacity 1s ease',
		pointerEvents: 'none'
	};
	const vissible  = {
		opacity: 1,
    transition: 'opacity 1s ease'
	};

	let styleHalf1 = vissible;
	let styleHalf2 = vissible;
	let styleHoogLaag = vissible;
	let styleBox = vissible;
	let styleMediaan = vissible;

	let styleValue50 = invissible;
	let styleValueBox = invissible;
	let styleValue90 = invissible;



	if (highlights.indexOf('show-mediaan') > -1) {
		styleMediaan = vissible;
		styleHalf1 = invissible;
		styleHalf2 = invissible;
	}

	if (highlights.indexOf('show-half-1') > -1) {
		styleMediaan = vissible;
		styleHalf1 = vissible;
		styleHalf2 = invissible;
	}

	if (highlights.indexOf('show-half-2') > -1) {
		styleMediaan = vissible;
		styleHalf1 = invissible;
		styleHalf2 = vissible;
	}


	if (highlights.indexOf('show-boxplot-hoog-laag') > -1) {
		styleHoogLaag = vissible;
		styleBox = invissible;
		styleMediaan = invissible;
		styleValue90 = vissible;
	}

	if (highlights.indexOf('show-boxplot-box') > -1) {
		styleHoogLaag = invissible;
		styleBox = vissible;
		styleMediaan = invissible;
		styleValueBox = vissible;
	}

	if (highlights.indexOf('show-boxplot-mediaan') > -1) {
		styleHoogLaag = invissible;
		styleBox = invissible;
		styleMediaan = vissible;
		styleValue50 = vissible;
	}

	let styleExplanationMedian = vissible;
	let styleExplanationBoxplot = invissible;

	if (currentStep === 12) {
		styleExplanationMedian = invissible;
		styleExplanationBoxplot = vissible;
	}

	const low = data[0];
	const high = data[data.length-1];
	const median = percentile(50, data);
	const per5 = percentile(5, data);
	const per25 = percentile(25, data);
	const per75 = percentile(75, data);
	const per95 = percentile(95, data);

	const scale = scaleLinear().domain(this.state.domain).range([30,450]);

	const dots = data.map((d,i) => {
		const thisX = scale(d);
		return (
			<g key={"dot"+i}>
				<circle cx={thisX} cy={0} r={3} fill="#fff"  />
				{d === dot ? <text x={thisX} y={-10} textAnchor="middle">{d}</text> : null}
			</g>
			)}
		)

	const ticks = [];
	for (var i = domain[0]; i <= domain[domain.length-1]; i++) {
		ticks.push(<tspan key={"tick"+i} x={scale(i)} y="0">{i}</tspan>)
	}

  return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 360">
		  <g strokeMiterlimit="10" fontFamily="Sans, RijksoverheidSansText-Regular, RijksoverheidSansText, sans-serif" >


		  <g className="explanationMedian" style={styleExplanationMedian} >

		  	<g style={styleMediaan}>
		    <text transform={`translate(${scale(median)} 30)`} fontWeight="700" fontSize="15" fill="#e5b2cf" textAnchor="middle">
			    mediaan
		    </text>
		    <line x1={scale(median)} y1="42" x2={scale(median)} y2="120" fill="none" stroke="#e5b2cf" strokeWidth="1" strokeDasharray="6 6" />
		    </g>

				<g transform="translate(0 132.5)" fill="#fff" >
					<rect x={30} y ={-200} width={420} height="100%" onMouseMove={this.handleMouseMove} onMouseOut={this.handleMouseOut} opacity={0} />
					<g style={ { pointerEvents: 'none'} }>{dots}</g>
				</g>


				<g style={styleHalf1} >
					<text transform={`translate(${scale((median + low)/2)} 240)`} fill="#e5b2cf" textAnchor="middle" fontWeight="700" fontSize="15">
						<tspan x="0" y="0">onderste helft</tspan>
						<tspan  x="0" y="15">van alle getallen</tspan>
					</text>
					<path
						d={`
							M ${scale(low)} 180
							v 20
							h ${(scale(median) - scale(low))/2 - 10}
							l 10 10
							l 10 -10
							h ${(scale(median) - scale(low))/2 - 10}
							v -20
						`}
						fill="none"
						stroke="#e5b2cf"
						strokeWidth="1"
						strokeDasharray="6 6"
					/>;
				</g>


				<g style={styleHalf2} >
					<text transform={`translate(${scale((median + high)/2)} 240)`} fill="#e5b2cf" textAnchor="middle" fontWeight="700" fontSize="15">
						<tspan x="0" y="0">bovenste helft</tspan>
						<tspan  x="0" y="15">van alle getallen</tspan>
					</text>
					<path
						d={`
							M ${scale(median)} 180
							v 20
							h ${(scale(high) - scale(median))/2 - 10}
							l 10 10
							l 10 -10
							h ${(scale(high) - scale(median))/2 - 10}
							v -20
						`}
						fill="none"
						stroke="#e5b2cf"
						strokeWidth="1"
						strokeDasharray="6 6"
					/>;
				</g>


		  </g>

		  <g className="explanationBoxplot" style={styleExplanationBoxplot}>
			  <g stroke="#fff">
			    <line x1={scale(per5)} x2={scale(per95)} y1="132.5" y2="132.5" fill="none" strokeWidth="6" stroke="#e5b2cf" />
			    <rect x={scale(per25)} y="112.5" width={scale(per75) - scale(per25)} height="40" fill="#e5b2cf" stroke="#e5b2cf" />
			    <line x1={scale(median)} x2={scale(median)} y1="102.5" y2="162.5" fill="none" strokeWidth="14" />
			  </g>
			  <g fontWeight="700" fontSize="15" fill="#fff" textAnchor="middle">


			  	<text style={styleValue50} x={scale(median)} y="190" fill="#e5b2cf">{median}</text>
			  	<text style={styleValueBox} x={scale(per25)} y="100" fill="#e5b2cf">{per25}</text>
			  	<text style={styleValueBox} x={scale(per75)} y="100" fill="#e5b2cf">{per75}</text>
			  	<text style={styleValue90} x={scale(per5)} y="190" fill="#e5b2cf">{per5}</text>
			  	<text style={styleValue90} x={scale(per95)} y="190" fill="#e5b2cf">{per95}</text>


					<g style={styleHoogLaag} >
						<text x={scale(per5)} y="30" fill="#e5b2cf">laagste waarde</text>
						<line x1={scale(per5)} x2={scale(per5)} y1="42" y2="122" fill="none" stroke="#e5b2cf" strokeWidth="2" strokeDasharray="5 5" />
						<text x={scale(per95)} y="30"fill="#e5b2cf">hoogste waarde</text>
						<line x1={scale(per95)} x2={scale(per95)} y1="42" y2="122" fill="none" stroke="#e5b2cf" strokeWidth="2" strokeDasharray="5 5" />
					</g>

					<g style={styleMediaan} >
						<text x={scale(median)} y="30" fill="#e5b2cf">mediaan</text>
						<line x1={scale(median)} x2={scale(median)} y1="42" y2="90" fill="none" stroke="#e5b2cf" strokeWidth="2" strokeDasharray="5 5" />
					</g>

					<g style={styleBox} >
						<text x={ scale((per75 + per25)/2) } y="240" fill="#e5b2cf" textAnchor="middle">omvat de helft van alle waarden</text>
						<path
							d={`
								M ${scale(per25)} 180
								v 20
								h ${(scale(per75) - scale(per25))/2 - 10}
								l 10 10
								l 10 -10
								h ${(scale(per75) - scale(per25))/2 - 10}
								v -20
							`}
							fill="none"
							stroke="#e5b2cf"
							strokeWidth="1"
							strokeDasharray="6 6"
						/>;
					</g>




			 </g>


			</g>

 				<g id="x-as">
			    <line x1="30" x2="450" y1="300" y2="300" fill="none" stroke="#fff" strokeMiterlimit="10" strokeWidth="1"/>
			    <text transform="translate(0 318)" fontSize="15" fill="#fff" textAnchor="middle">
				   	{ticks}
			   	</text>
			  </g>
			</g>
		</svg>

  )
	}
}


export default VisUitleg;



// WEBPACK FOOTER //
// ./src/components/Visualization/VisUitleg.js